// src/service/WaitingRoomAdmin.js
import instance from '../apis/app';

class WaitingRoomAdminService {
  async getStats() {
    const res = await instance.get('/waiting-room/admin/stats');
    return res;
  }

  async getUsuarios() {
    const res = await instance.get('/waiting-room/admin/usuarios');
    return res;
  }

  async setConfig(data) {
    const res = await instance.patch('/waiting-room/admin/config', data);
    return res;
  }

  async expulsar(userId) {
    const res = await instance.delete(`/waiting-room/admin/expulsar/${encodeURIComponent(userId)}`);
    return res;
  }

  async limpiarCola() {
    const res = await instance.delete('/waiting-room/admin/limpiar-cola');
    return res;
  }

  async limpiarExpirados() {
    const res = await instance.delete('/waiting-room/admin/limpiar-expirados');
    return res;
  }

  async desconectarTodos() {
    const res = await instance.delete('/waiting-room/admin/desconectar-todos');
    return res;
  }

}

export default new WaitingRoomAdminService();
